/* eslint-disable import/extensions */
/* eslint-disable object-curly-newline */
/* eslint-disable react/jsx-filename-extension */
import Icons1 from "../assets/images/FAQsIcons/IconFaqs1.svg";
import Icons2 from "../assets/images/FAQsIcons/IconFaqs2.svg";
import Icons3 from "../assets/images/FAQsIcons/IconFaqs3.svg";
import Icons4 from "../assets/images/FAQsIcons/IconFaqs4.svg";
import Icons5 from "../assets/images/FAQsIcons/IconFaqs5.svg";
import Icons6 from "../assets/images/FAQsIcons/IconFaqs6.svg";
import Icons7 from "../assets/images/FAQsIcons/IconFaqs7.svg";
import Icons8 from "../assets/images/FAQsIcons/IconFaqs8.svg";
import Icons9 from "../assets/images/FAQsIcons/IconFaqs9.svg";
import Icons10 from "../assets/images/FAQsIcons/IconFaqs10.svg";
import Icons11 from "../assets/images/FAQsIcons/IconFaqs11.svg";
import Icons12 from "../assets/images/FAQsIcons/IconFaqs12.svg";
import Icons13 from "../assets/images/FAQsIcons/IconFaqs13.svg";
import Icons14 from "../assets/images/FAQsIcons/IconFaqs14.svg";
import Icons15 from "../assets/images/FAQsIcons/IconFaqs15.svg";
import Icons16 from "../assets/images/FAQsIcons/IconFaqs16.svg";
import Icons17 from "../assets/images/FAQsIcons/IconFaqs17.svg";
import Icons18 from "../assets/images/FAQsIcons/IconFaqs18.svg";
import Icons19 from "../assets/images/FAQsIcons/IconFaqs19.svg";

export const DataAccordion = [
  {
    id: 1,
    question: "What does Nube iO do?",
    answer:
      "From a single building to entire portfolios, Nube iO unifies devices, systems, and spaces — making automation smarter, simpler, and future-ready.",
    icons: Icons1,
  },
  {
    id: 2,
    question: "Who can benefit from Nube iO solutions?",
    answer:
      "Our technology serves facility managers, OEM partners, system integrators, engineers, and businesses seeking scalable IoT solutions for energy efficiency, automation, and sustainability.",
    icons: Icons2,
  },
  {
    id: 3,
    question: "Where are Nube iO products designed and manufactured?",
    answer:
      "All Nube iO products are proudly designed and engineered in Australia, ensuring global standards of quality, innovation, and sustainability.",
    icons: Icons3,
  },
  {
    id: 4,
    question: "What types of hardware does Nube iO offer?",
    answer:
      "Nube iO provides controllers (e.g. Rubix Compute, Rubix IO-16), LoRa® wireless sensors (Droplet Indoor Sensor, MicroEdge Sensor), and Expansion Modules (Rubix Connect LW).",
    icons: Icons4,
  },
  {
    id: 5,
    question: " Can Nube iO hardware integrate with existing systems?",
    answer:
      "Yes, our hardware seamlessly integrates with both legacy and modern building management systems, enhancing performance without significant infrastructure overhauls.",
    icons: Icons5,
  },
  {
    id: 6,
    question: "What is LoRa®, and why does Nube iO use it?",
    answer:
      "LoRa® (Long Range) is a wireless technology enabling reliable, secure communication over extended distances with low power consumption. Nube iO leverages LoRa® for cost-effective, scalable deployments and superior data reliability.",
    icons: Icons6,
  },
  {
    id: 7,
    question: "What software solutions does Nube iO provide?",
    answer:
      "Our software portfolio includes Rubix CE, a cloud-based management platform (Nube iO Cloud), and extensive API connectivity services for seamless third-party integrations.",
    icons: Icons7,
  },
  {
    id: 8,
    question: "Can I remotely manage multiple buildings with Nube iO software?",
    answer:
      "Absolutely. Nube iO Cloud provides a centralised interface, enabling real-time monitoring and management of multiple sites from anywhere in the world.",
    icons: Icons8,
  },
  {
    id: 9,
    question: "Is special training required to operate Nube iO software?",
    answer:
      "No. Our software is designed to be intuitive and user-friendly, but we also offer comprehensive training and professional support services to maximise user confidence and efficiency.",
    icons: Icons9,
  },
  {
    id: 10,
    question: "What professional services does Nube iO offer?",
    answer:
      "We offer customised solutions including system design and integration, data analytics, compliance and sustainability consulting, predictive maintenance, and comprehensive support",
    icons: Icons10,
  },
  {
    id: 11,
    question: "Does Nube iO provide ongoing support?",
    answer:
      "Yes. Our professional services team provides proactive, ongoing support to ensure smooth implementation, optimal system performance, and continuous improvement.",
    icons: Icons11,
  },
  {
    id: 12,
    question: "Can Nube iO solutions be customised for OEM partners?",
    answer:
      "Yes. We offer fully customisable and white-labelled solutions designed specifically for OEM partners, enabling you to leverage our advanced technology stack under your brand.",
    icons: Icons12,
  },
  {
    id: 13,
    question:
      "What advantages do OEM partners receive from collaborating with Nube iO?",
    answer:
      "OEM partners benefit from innovative technology, scalable and adaptable products, seamless integration capabilities, and dedicated technical support to enhance competitiveness and market differentiation.",
    icons: Icons13,
  },
  {
    id: 14,
    question: "How do Nube iO solutions support sustainability?",
    answer:
      "Our technology is specifically designed to optimise energy consumption, reduce environmental impact, and support compliance with local and international sustainability standards and regulations.",
    icons: Icons14,
  },
  {
    id: 15,
    question:
      "Can Nube iO help buildings achieve regulatory compliance (e.g. NABERS)?",
    answer:
      "Absolutely. Nube iO solutions support various compliance standards such as NABERS, Green Star, and other global sustainability certifications by providing accurate reporting, analytics, and energy-efficient technology.",
    icons: Icons15,
  },
  {
    id: 16,
    question: "How can I purchase Nube iO products?",
    answer:
      "You can purchase directly through our sales team or authorised distributors. Contact us to discuss your needs, request quotes, or arrange a product demonstration.",
    icons: Icons16,
  },
  {
    id: 17,
    question: "Does Nube iO provide installation support?",
    answer:
      "Yes, our experienced professional services team provides comprehensive installation support, from initial planning and deployment to ongoing maintenance and optimisation.",
    icons: Icons17,
  },
  {
    id: 18,
    question: "Where can I find technical manuals and documentation?",
    answer:
      "All technical manuals, installation guides, and support resources are available in our Knowledge Base on GitHub.",
    icons: Icons18,
  },
  {
    id: 19,
    question: "How can I get technical support if I encounter an issue?",
    answer:
      "Contact our dedicated support team via email, phone, or through our online support portal. We are committed to ensuring your issues are resolved quickly and effectively.",
    icons: Icons19,
  },
];
